import { useContext } from "react";
import {
  getRebrandBannerOffsetPx,
  getTotalTopOffsetPx,
  IS_ADLE_DOMAIN,
  IS_WHITE_LABEL_BRAND,
  OWNER_ROLE,
  REBRAND_BANNER_HEIGHT,
} from "../utils/constants";
import { UNSAFE_LocationContext as LocationContext } from "react-router-dom";
import { isRebrandBannerExcludedPath } from "../router/formRoutes";
import { useSelectorApp } from "../lib/redux";

/** Works inside Router and in SweetAlert portals (no Router ancestor). */
const usePathname = () => {
  const locationContext = useContext(LocationContext);
  return locationContext?.location?.pathname ?? window.location.pathname;
};

export const useRebrandBanner = () => {
  const pathname = usePathname();
  const { user } = useSelectorApp((state) => state.auth);
  const isOwner = user?.role === OWNER_ROLE;
  const showBanner =
    IS_ADLE_DOMAIN &&
    !IS_WHITE_LABEL_BRAND &&
    !isRebrandBannerExcludedPath(pathname) &&
    !isOwner;

  const rebrandBannerOffsetPx = getRebrandBannerOffsetPx({ showBanner });
  const totalTopOffsetPx = getTotalTopOffsetPx({ showBanner });
  const navbarTop = showBanner ? `${REBRAND_BANNER_HEIGHT}px` : "0px";

  return {
    showBanner,
    rebrandBannerOffsetPx,
    navbarTop,
    totalTopOffsetPx,
  };
};
